export default __webpack_public_path__ + "static/media/sp_chevron_down.9ee8d123.svg";